module.exports = __webpack_public_path__ + "img/img33.cb960d62.svg";